module.exports = __webpack_public_path__ + "static/media/icon-edit-avatar.1afdd902.svg";